"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Enlighten = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
class Enlighten {
}
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], Enlighten.prototype, "apiKey", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], Enlighten.prototype, "storeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], Enlighten.prototype, "menuFeedName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], Enlighten.prototype, "menuFeedId", void 0);
exports.Enlighten = Enlighten;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW5saWdodGVuLmpzIiwic291cmNlUm9vdCI6Ii4vc3JjLyIsInNvdXJjZXMiOlsicGFja2FnZXMvbW9kZWxzL3NyYy9lbmxpZ2h0ZW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLHFDQUFpQztBQUVqQyxNQUFhLFNBQVM7Q0FTckI7QUFSRztJQUFDLElBQUEsZ0JBQU0sRUFBQyxFQUFFLFFBQVEsRUFBRSxJQUFJLEVBQUUsQ0FBQzs7eUNBQ1o7QUFDZjtJQUFDLElBQUEsZ0JBQU0sRUFBQyxFQUFFLFFBQVEsRUFBRSxJQUFJLEVBQUUsQ0FBQzs7MENBQ1g7QUFDaEI7SUFBQyxJQUFBLGdCQUFNLEVBQUMsRUFBRSxRQUFRLEVBQUUsSUFBSSxFQUFFLENBQUM7OytDQUNOO0FBQ3JCO0lBQUMsSUFBQSxnQkFBTSxFQUFDLEVBQUUsUUFBUSxFQUFFLElBQUksRUFBRSxDQUFDOzs2Q0FDUjtBQVJ2Qiw4QkFTQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENvbHVtbiB9IGZyb20gXCJ0eXBlb3JtXCI7XG5cbmV4cG9ydCBjbGFzcyBFbmxpZ2h0ZW4ge1xuICAgIEBDb2x1bW4oeyBudWxsYWJsZTogdHJ1ZSB9KVxuICAgIGFwaUtleTogc3RyaW5nO1xuICAgIEBDb2x1bW4oeyBudWxsYWJsZTogdHJ1ZSB9KVxuICAgIHN0b3JlSWQ6IHN0cmluZztcbiAgICBAQ29sdW1uKHsgbnVsbGFibGU6IHRydWUgfSlcbiAgICBtZW51RmVlZE5hbWU6IHN0cmluZztcbiAgICBAQ29sdW1uKHsgbnVsbGFibGU6IHRydWUgfSlcbiAgICBtZW51RmVlZElkOiBzdHJpbmc7XG59Il19